var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Signin',{attrs:{"forgotPasswordRoute":_vm.forgotPasswordRoute},on:{"failed":_vm.failed}})
}
var staticRenderFns = []

export { render, staticRenderFns }